import { type IntlShape } from "react-intl";
import { z } from "zod";

const classificationStatuses = ["Expedite", "Normal", "Last", "Stop"] as const;
export const classificationStatusSchema = (intl: IntlShape) =>
	z.enum(
		classificationStatuses,
		intl.formatMessage({ id: "Classification status is invalid", defaultMessage: "Classification status is invalid" }),
	);

export const classificationConfigurationSchema = (intl: IntlShape) =>
	z.object({
		number: z
			.number(intl.formatMessage({ id: "Number needs to be a number", defaultMessage: "Number needs to be a number" }))
			.int(intl.formatMessage({ id: "Number needs to be an integer", defaultMessage: "Number needs to be an integer" }))
			.min(0, intl.formatMessage({ id: "Number must be 0 or greater", defaultMessage: "Number must be 0 or greater" })),
		alias: z
			.string(intl.formatMessage({ id: "Alias needs to be a string", defaultMessage: "Alias needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Alias can not be empty", defaultMessage: "Alias can not be empty" })),
		isPriorityLabel: z.boolean(
			intl.formatMessage({
				id: "IsPriorityLabel needs to be a boolean",
				defaultMessage: "IsPriorityLabel needs to be a boolean",
			}),
		),
	});

export const classificationSchema = (intl: IntlShape) =>
	classificationConfigurationSchema(intl).extend({
		id: z
			.string(intl.formatMessage({ id: "Id needs to be a string", defaultMessage: "Id needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Id can not be empty", defaultMessage: "Id can not be empty" })),
		tenantId: z
			.string(
				intl.formatMessage({ id: "TenantId needs to be a string", defaultMessage: "TenantId needs to be a string" }),
			)
			.trim()
			.nonempty(intl.formatMessage({ id: "TenantId can not be empty", defaultMessage: "TenantId can not be empty" })),
		status: classificationStatusSchema(intl),
		builtInClassification: z.boolean(
			intl.formatMessage({
				id: "BuiltInClassification needs to be a boolean",
				defaultMessage: "BuiltInClassification needs to be a boolean",
			}),
		),
	});

export type Classification = z.infer<ReturnType<typeof classificationSchema>>;
export type ClassificationConfiguration = z.infer<ReturnType<typeof classificationConfigurationSchema>>;
export type ClassificationStatus = z.infer<ReturnType<typeof classificationStatusSchema>>;
